<template>
  <ag-modal-container
    :title="$t('company.title.createCompany')"
    width="900px"
    @close="back"
  >
    <create-company-form
      v-model="value"
      :forbidden-company-list="forbiddenCompanyList"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="loading"
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || loading"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.create')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'

import CreateCompanyForm from '../components/CreateCompanyForm'

export default {
  name: 'CompanyCreateContainer',
  components: {
    AgModalContainer,
    CreateCompanyForm,
  },
  data () {
    return {
      value: {
        duplicateCompanyId: '',
        companyLogin: '',
        displayName: '',
        masterContactList: [],
      },
      isValid: false,
      loading: false,
      forbiddenCompanyList: [],
    }
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.company.post(this.value)
        this.showSuccessNotification(this.$t('company.companyCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)

        // Username already exists
        if (Repositories.getErrorCode(error) === 'CreateCompanyLoginTakenError') {
          this.forbiddenCompanyList.push(this.value.companyLogin)
        }
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
